/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ReportWrapper_devices = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportWrapper_devices",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ReportHeader_devices",
      "args": null
    }
  ],
  "type": "DeviceConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/__generated__/ReportWrapper_devices.graphql.js